const EVENT_TYPE_ORDER = [
  'absence',
  'frame',
  'subject',
  'optional',
  'person_resource_visible',
  ['resource', 'person_resource'],
  'supplemental',
  'break',
  'additional_tasks'
]

const EVENT_TYPE_PRIORITY = EVENT_TYPE_ORDER.reduce((acc, types, idx) => {
  ;[].concat(types).forEach(type => { acc[type] = idx })
  return acc
}, {})

const getEventTypePriority = (eventType) => {
  return eventType in EVENT_TYPE_PRIORITY ? EVENT_TYPE_PRIORITY[eventType] : EVENT_TYPE_ORDER.length
}

export const compareEventsByType = (e1, e2) => {
  const diff = getEventTypePriority(e1.obj.event_type) - getEventTypePriority(e2.obj.event_type)
  if (diff !== 0) return diff
  return (e1.obj.title || '').localeCompare(e2.obj.title || '', 'da')
}



// WEBPACK FOOTER //
// ./src/components/DCalendar/eventTypeOrder.js